import React from 'react'
import { ListPost } from '../../../components/Web/Blog'
export function Blog() {
  return (
    <div>
      <ListPost />
    </div>
  )
}
